<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-flex xs12 sm3>
        <Comment />
      </v-flex>
      <v-flex xs12 sm8 md8>
        <v-container grid-list-md>
          <v-card v-if="isDataLoaded">
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Project preview</span>
              </div>
            </v-card-title>
            <v-card-text>
              <template>
                <v-data-table
                  :items="indexData.projectData"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <!-- <template> -->
                    <tr>
                      <td>Project Id</td>
                      <td class="text-xs-left">
                        {{ props.item.id }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project Name</td>
                      <td class="text-xs-left">
                        {{ props.item.name }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project type</td>
                      <td class="text-xs-left">
                        {{
                          indexData.projectType[props.item.project_type_id - 1]
                            .name
                        }}
                      </td>
                    </tr>

                    <tr>
                      <td>Project Language</td>
                      <td class="text-xs-left">
                        {{ props.item.project_language }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project Description</td>
                      <td class="text-xs-left">{{ props.item.details }}</td>
                    </tr>
                    <tr v-if="props.item.has_pre_survey == 1">
                      <td>Pre Survey Description</td>
                      <td class="text-xs-left">
                        {{ props.item.pre_survey_descriptions }}
                      </td>
                    </tr>
                    <tr>
                      <td>Estimated Starting Time</td>
                      <td class="text-xs-left">{{ props.item.begin_date }}</td>
                    </tr>
                    <tr>
                      <td>Estimated Ending Time</td>
                      <td class="text-xs-left">{{ props.item.end_date }}</td>
                    </tr>
                    <tr>
                      <td>Total Budget(Tk)</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_amount }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Total Budget(coins)</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_coins }}
                      </td>
                    </tr>
                    <tr>
                      <td v-if="props.item.project_status_id >= 8">
                        Per Survey Cost(Coins)
                      </td>
                      <td v-else>Per Survey Cost(Tk)</td>
                      <td class="text-xs-left">
                        {{ props.item.per_survey_cost }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Response</td>
                      <td class="text-xs-left">
                        {{ props.item.number_of_response }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </template>
              <!-- <v-divider></v-divider> -->
            </v-card-text>
            <preview-location
              :projectId="parseInt(data.project_id)"
              v-if="editedItem.projectInfo.project_type_id == 2"
            ></preview-location>

            <v-card v-if="indexData.projectData[0].has_pre_survey">
              <v-card-title class="project">
                <div>
                  <span class="headline white--text">Pre Survey Question</span>
                </div>
              </v-card-title>
              <v-card-text>
                <div>
                  <div
                    v-for="(pre_ques, index) in editedItem.preQuestions"
                    v-bind:key="index"
                  >
                    <!-- pre-survey question part -->
                    <br />
                    <div>
                      <span v-if="pre_ques.question == ''" class="red--text">
                        {{ q_validate }} <br />
                      </span>
                      <span>Pre_Q{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.projectData[0].project_language == 1 ||
                          indexData.projectData[0].project_language == 3
                        "
                      >
                        <span class="font-weight-bold"
                          >Question Title English:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question }}
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.projectData[0].project_language == 2 ||
                          indexData.projectData[0].project_language == 3
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold"
                          >Question Title Bangla:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question_bangla }} <br />
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                    </div>
                    <!-- option and multiple image section -->
                    <div
                      v-if="
                        pre_ques.ui_category_id == 1 ||
                        pre_ques.ui_category_id == 2 ||
                        pre_ques.ui_category_id == 4 ||
                        pre_ques.ui_category_id == 14
                      "
                    >
                      <div v-if="pre_ques.ui_category_id == 14">
                        <span v-for="(option, i) in pre_ques.images" :key="i">
                          <br /><v-img
                            height="150"
                            width="200"
                            :src="indexData.preQuesImageUrl + option.url"
                          ></v-img>
                          <div class="mt-3">
                            {{ i + 1 }} . {{ option.name }}
                          </div>
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 1 &&
                          (indexData.projectData[0].project_language == 1 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span v-for="(option, i) in pre_ques.radios" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 1 &&
                          (indexData.projectData[0].project_language == 2 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in pre_ques.radios_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 2 &&
                          (indexData.projectData[0].project_language == 1 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span
                          v-for="(option, i) in pre_ques.checkboxes"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 2 &&
                          (indexData.projectData[0].project_language == 2 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in pre_ques.checkboxes_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 4 &&
                          (indexData.projectData[0].project_language == 1 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span
                          v-for="(option, i) in pre_ques.dropdowns"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 4 &&
                          (indexData.projectData[0].project_language == 2 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in pre_ques.dropdowns_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.name }}
                        </span>
                      </div>
                    </div>
                    <!-- instruction and description -->
                    <div>
                      <span
                        v-if="
                          pre_ques.instruction != null &&
                          (indexData.projectData[0].project_language == 1 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        <span class="font-weight-bold"> Instruction: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.instruction"></div>
                      </span>
                      <span
                        v-if="
                          pre_ques.instruction_bangla != null &&
                          (indexData.projectData[0].project_language == 2 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        <span class="font-weight-bold">
                          Instruction Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.instruction_bangla"></div>
                      </span>

                      <span
                        v-if="
                          pre_ques.description != null &&
                          (indexData.projectData[0].project_language == 1 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        <span class="font-weight-bold"> Description: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.description"></div>
                      </span>
                      <span
                        v-if="
                          pre_ques.description_bangla != null &&
                          (indexData.projectData[0].project_language == 2 ||
                            indexData.projectData[0].project_language == 3)
                        "
                      >
                        <span class="font-weight-bold">
                          Description Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.description_bangla"></div>
                      </span>
                    </div>
                    <div>
                      <pre-survey-question-logic-preview
                        :pre_question_logic="pre_ques.logic_set"
                        :operators="indexData.operators"
                      />
                    </div>
                    <!-- <br /> -->
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card>
              <v-card-title class="project">
                <div><span class="headline white--text">Question</span></div>
              </v-card-title>
              <v-card-text>
                <div>
                  <span class="font-weight-bold"
                    >Note:Here star mark (<span class="red--text">*</span>) is
                    required.</span
                  >
                  <br />
                  <div
                    v-for="(ques, index) in editedItem.questions"
                    v-bind:key="index"
                  >
                    <!-- question part -->
                    <br />
                    <div>
                      <span v-if="ques.question == ''" class="red--text">
                        {{ q_validate }} <br />
                      </span>
                      <span>{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.projectData[0].project_language == '1' ||
                          indexData.projectData[0].project_language == '3'
                        "
                      >
                        <span class="font-weight-bold"
                          >Question Title English:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ ques.question }}
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.projectData[0].project_language == '2' ||
                          indexData.projectData[0].project_language == '3'
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold"
                          >Question Title Bangla:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }} <br />
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span>
                        <span class="font-weight-bold">Question Type:</span>
                        &nbsp;&nbsp;&nbsp;{{
                          indexData.uiCategory[ques.ui_category_id - 1].name
                        }}
                        <br />
                      </span>
                    </div>
                    <!-- option and multiple image section -->
                    <div
                      v-if="
                        ques.ui_category_id == 1 ||
                        ques.ui_category_id == 2 ||
                        ques.ui_category_id == 4 ||
                        ques.ui_category_id == 14
                      "
                    >
                      <div v-if="ques.ui_category_id == 14">
                        <span v-for="(option, i) in ques.images" :key="i">
                          <br /><v-img
                            v-if="
                              option.url.includes('.png') ||
                              option.url.includes('.jpg')
                            "
                            height="150"
                            width="200"
                            :src="indexData.quesImageUrl + option.url"
                          ></v-img>
                          <v-img
                            v-else
                            height="150"
                            width="200"
                            :src="'data:image.png;base64,' + option.url"
                          ></v-img>
                          <div class="mt-3"></div>
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 1 &&
                          (indexData.projectData[0].project_language == '1' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        Option English: <br />
                        <span v-for="(option, i) in ques.radios" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 1 &&
                          (indexData.projectData[0].project_language == '2' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in ques.radios_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 2 &&
                          (indexData.projectData[0].project_language == '1' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        Option English: <br />
                        <span v-for="(option, i) in ques.checkboxes" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 2 &&
                          (indexData.projectData[0].project_language == '2' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in ques.checkboxes_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 4 &&
                          (indexData.projectData[0].project_language == '1' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        Option English: <br />
                        <span v-for="(option, i) in ques.dropdowns" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 4 &&
                          (indexData.projectData[0].project_language == '2' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in ques.dropdowns_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.title }}
                        </span>
                      </div>
                    </div>
                    <!-- instruction and description -->
                    <div>
                      <span
                        v-if="
                          ques.instruction != null &&
                          (indexData.projectData[0].project_language == '1' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        <span class="font-weight-bold"> Instruction: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.instruction"></div>
                      </span>
                      <span
                        v-if="
                          ques.instruction_bangla != null &&
                          (indexData.projectData[0].project_language == '2' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        <span class="font-weight-bold">
                          Instruction Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.instruction_bangla"></div>
                      </span>

                      <span
                        v-if="
                          ques.description != null &&
                          (indexData.projectData[0].project_language == '1' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        <span class="font-weight-bold"> Description: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.description"></div>
                      </span>
                      <span
                        v-if="
                          ques.description_bangla != null &&
                          (indexData.projectData[0].project_language == '2' ||
                            indexData.projectData[0].project_language == '3')
                        "
                      >
                        <span class="font-weight-bold">
                          Description Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.description_bangla"></div>
                      </span>
                    </div>
                    <!-- date time question -->
                    <div v-if="ques.ui_category_id == 12">
                      <span
                        class="font-weight-bold"
                        v-if="ques.date_time != null"
                      >
                        {{ ques.date_time }}
                      </span>
                    </div>

                    <!-- range slider star rating -->
                    <div
                      v-if="
                        ques.ui_category_id == 6 ||
                        ques.ui_category_id == 7 ||
                        ques.ui_category_id == 8
                      "
                    >
                      <div v-if="ques.ui_category_id == 6">
                        <span
                          class="font-weight-bold"
                          v-if="ques.range.min != '' && ques.range.max != ''"
                        >
                          Min value: {{ ques.range.min }}<br />
                          Max value: {{ ques.range.max }}
                        </span>
                      </div>
                      <div v-if="ques.ui_category_id == 7">
                        <span
                          class="font-weight-bold"
                          v-if="
                            ques.slider.min_value != '' &&
                            ques.slider.max_value != ''
                          "
                        >
                          Min value: {{ ques.slider.min }}<br />
                          Max value: {{ ques.slider.max }}
                        </span>
                        <span
                          class="font-weight-bold"
                          v-if="ques.slider.interval != ''"
                        >
                          <br />
                          interval: {{ ques.slider.interval }}
                        </span>
                      </div>
                    </div>
                    <!-- multiple answer -->
                    <div v-if="ques.ui_category_id == 15">
                      <span v-if="ques.contactInfo.first_name == true">
                        First Name: _________
                      </span>
                      <span v-if="ques.contactInfo.middle_name == true">
                        <br />
                        Middle Name: _________
                      </span>
                      <span v-if="ques.contactInfo.last_name == true">
                        <br />
                        Last Name: _________
                      </span>
                      <span v-if="ques.contactInfo.phone == true">
                        <br />
                        <v-icon small> call </v-icon>Phone: _________
                      </span>
                      <span v-if="ques.contactInfo.email == true">
                        <br />email: _________
                      </span>
                      <span v-if="ques.contactInfo.address == true">
                        <br /><v-icon small> home </v-icon
                        ><span class="font-weight-bold"> Address:</span>
                        <br />Country: _________ <br />Division: _________
                        <br />District : _________ <br />Area: _________
                        <br />Road No: _________ <br />House No: _________
                      </span>
                    </div>
                    <span class="font-weight-bold">Multiple ans:</span>
                    <v-icon small class="mr-1">check_box_outline_blank</v-icon>
                    <span v-if="ques.multiple_answer == 1">yes</span>
                    <span v-else>no</span>
                    <!-- <br /> -->
                    <div v-if="ques.has_logic">
                      <question-logic
                        :question_logic="ques.logic_group"
                        :questions="editedItem.questions"
                        :counter_index="index"
                      />
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <v-card>
              <v-card-title
                class="project"
                v-if="
                  editedItem.filter_skip == '0' &&
                  indexData.projectData[0].project_type_id == '1'
                "
              >
                <div>
                  <span class="headline white--text"
                    >Project Filtering Parameters</span
                  >
                </div>
              </v-card-title>
              <v-card-text
                v-if="
                  editedItem.filter_skip == '0' &&
                  indexData.projectData[0].project_type_id == '1'
                "
              >
                <div>
                  <v-card
                    v-for="(filter_group, index) in editedItem.filter_data"
                    v-bind:key="index"
                  >
                    <v-btn class="fa-pull-right"> Group - {{ index }}</v-btn>
                    <v-card-text
                      row
                      v-for="(
                        add_filtering, counter
                      ) in filter_group.add_filterings"
                      v-bind:key="counter"
                    >
                      <div class="col-md-4">
                        {{
                          ProjectFilterBasicData.ProjectFilteringParameter[
                            add_filtering.filtering_parameter_id - 1
                          ].name
                        }}
                      </div>
                      <div class="col-md-4">
                        {{
                          ProjectFilterBasicData.operators[
                            add_filtering.comparison_operator_id - 1
                          ].name
                        }}
                      </div>
                      <div
                        class="col-md-4"
                        v-if="add_filtering.filtering_parameter_id == 1"
                      >
                        age: {{ add_filtering.age1 }}
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 2"
                      >
                        <span
                          v-for="(
                            gender, gender_index
                          ) in add_filtering.gender_id"
                          :key="gender_index"
                        >
                          {{
                            ProjectFilterBasicData.genders[gender - 1].name
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 3"
                      >
                        <span
                          v-for="(
                            division, division_index
                          ) in add_filtering.division_id"
                          :key="division_index"
                        >
                          {{
                            ProjectFilterBasicData.divisions[division - 1]
                              .english_title
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 4"
                      >
                        <span
                          v-for="(
                            district, district_index
                          ) in add_filtering.district_id"
                          :key="district_index"
                        >
                          {{
                            ProjectFilterBasicData.districts[district - 1]
                              .english_title
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 5"
                      >
                        <span
                          v-for="(
                            education, education_index
                          ) in add_filtering.education_id"
                          :key="education_index"
                        >
                          {{
                            ProjectFilterBasicData.educations[education - 1]
                              .name
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 6"
                      >
                        <span
                          v-for="(
                            profession, profession_index
                          ) in add_filtering.profession_id"
                          :key="profession_index"
                        >
                          {{
                            ProjectFilterBasicData.professions[profession - 1]
                              .name
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div class="col-md-4" v-else>
                        <span
                          v-for="(
                            income, income_index
                          ) in add_filtering.income_id"
                          :key="income_index"
                        >
                          {{
                            ProjectFilterBasicData.income[income - 1].name
                          }}
                          &nbsp;
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                  <v-card-text>
                    Available Dasher on this filter is:
                    {{ editedItem.available_dasher }}
                  </v-card-text>
                </div>
              </v-card-text>
            </v-card>
            <assigned-agent-group-to-project
              v-if="indexData.projectData[0].dasher_category_id == 3"
              :project_id="indexData.projectData[0].id"
            ></assigned-agent-group-to-project>
            <assigned-teams-to-project
              v-if="indexData.projectData[0].dasher_category_id == 2"
              :project_id="indexData.projectData[0].id"
            ></assigned-teams-to-project>
            <v-card-actions>
              <v-spacer></v-spacer>
              <button class="button" flat @click="back">Back</button>
              <v-btn
                class="button"
                flat
                @click="submit"
                :disabled="clicked || q_blank_status"
              >
                {{ check_submit }}
              </v-btn>
              <!-- <v-btn class="button" flat @click="submit" :disabled="clicked">Submit</v-btn> -->
            </v-card-actions>
            <!-- <v-btn @click="save">submit</v-btn> -->
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router";
import Comment from "./Comment";
import PreviewLocation from "../components/PreviewLocation";
import {
  QuestionLogic,
  PreSurveyQuestionLogicPreview,
  AssignedAgentGroupToProject,
  AssignedTeamsToProject,
} from "@/components/index";

export default {
  components: {
    Comment,
    QuestionLogic,
    PreSurveyQuestionLogicPreview,
    PreviewLocation,
    AssignedAgentGroupToProject,
    AssignedTeamsToProject,
  },
  data: () => ({
    apiUrl: "project-info-details",
    clicked: false,
    q_blank_status: false,
    divisions: [],
    districts: [],
    upazilas: [],
    teams: [],
    sl: 1,
    headers: [
      { text: "Division Name", align: "left", value: "division_id" },
      { text: "District Name", align: "left", value: "district_id" },
      { text: "Upazila Name", align: "left", value: "upazila_id" },
      { text: "Area", value: "area" },
      { text: "Zip Code", value: "zip_code" },
      { text: "Latitude", value: "latitude" },
      { text: "Longitude", value: "longtude" },
      { text: "Address", value: "address" },
    ],
    loading: false,
    search: "",
    pagination: {},
    rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
    editedIndex: -1,
    img_op: null,
    ProjectFilterBasicData: {
      ProjectFilteringParameter: [],
      districts: [],
      divisions: [],
      educations: [],
      genders: [],
      income: [],
      operators: [],
      professions: [],
      upazila: [],
    },
    editedItem: {
      projectData: [
        {
          // project data
          name: "",
          project_type_id: "",
          details: "",
          begin_date: "",
          end_date: "",
          duration: "",
          project_language: "",
          total_budget_amount: 0,
          per_survey_cost: 0,
          number_of_response: 0,
        },
      ],
      projectInfo: {
        // project data
        name: "",
        project_type_id: "",
        details: "",
        begin_date: "",
        end_date: "",
        duration: "",
        project_language: "",
        total_budget_amount: 0,
        per_survey_cost: 0,
        number_of_response: 0,
      },

      questions: [
        {
          question: "",
          ui_category_id: "",
          required_optional: "",
          multiple_answer: "",
          instruction: "",
          description: "",
          boolean1: false,
          boolean2: false,
          date_time: "date & time",
          radios: [
            {
              name: "option1",
            },
          ],
          checkboxes: [
            {
              name: "option1",
            },
          ],
          dropdowns: [
            {
              name: "option1",
            },
          ],
          images: [
            {
              url: "",
            },
          ],
          range: {
            min: "",
            max: "",
          },
          slider: {
            min: "",
            max: "",
            interval: "",
          },
          starRating: {
            min: "",
            max: "",
            interval: "",
          },
          contactInfo: {
            first_name: true,
            middle_name: true,
            last_name: false,
            phone: true,
            email: true,
            address: false,
          },
        },
      ],
      preQuestions: [],
      teamToProjectData: [],
      filter_data: [],

      locationBased: [],
      filter_skip: false,
      available_dasher: null,
    },
    data: {
      project_id: null,
      questions: [],
      preQuestions: [],
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    q_validate: function () {
      this.blank_check();
      return "Question should not be blank";
    },
    check_submit() {
      if (this.q_blank_status == true) {
        return "contains error";
      } else {
        return "SUBMIT";
      }
    },
    isDataLoaded: function () {
      this.loadData();
      if (this.indexData.projectData) {
        return true;
      } else {
        return false;
      }
    },
  },

  created() {
    this.initialize();
  },
  methods: {
    // initialize editing data
    initialize() {
      var project_id_modify = JSON.parse(
        localStorage.getItem("project_id_modify")
      );
      this.data.project_id = project_id_modify;
      this.$store.dispatch("indexData", [this.apiUrl, project_id_modify]);
    },
    loadData() {
      if (this.indexData.projectData) {
        if (this.indexData.projectData[0].dasher_category_id == 2) {
          this.editedItem.teamToProjectData = JSON.parse(
            this.indexData.projectData[0].assigned_team_to_project
          );
        }
        this.editedItem.projectInfo.project_type_id =
          this.indexData.projectData[0].project_type_id;
        this.editedItem.filter_skip = this.indexData.projectData[0].filter_skip;
        if (
          this.editedItem.projectInfo.project_type_id == 1 &&
          this.editedItem.filter_skip != 1
        ) {
          var filteringData = JSON.parse(
            this.indexData.projectData[0].filtering_parameters
          );
          this.ProjectFilterBasicData.ProjectFilteringParameter =
            this.indexData.ProjectFilteringParameter;
          this.ProjectFilterBasicData.districts = this.indexData.districts;
          this.ProjectFilterBasicData.divisions = this.indexData.divisions;
          this.ProjectFilterBasicData.educations = this.indexData.educations;
          this.ProjectFilterBasicData.genders = this.indexData.genders;
          this.ProjectFilterBasicData.income = this.indexData.income;
          this.ProjectFilterBasicData.operators = this.indexData.operators;
          this.ProjectFilterBasicData.professions = this.indexData.professions;
          this.ProjectFilterBasicData.upazila = this.indexData.upazila;
          this.editedItem.filter_data = filteringData;
        }

        var questionData = JSON.parse(
          this.indexData.projectData[0].project_question_json
        );
        this.editedItem.questions = questionData.questions;
        var preQuestionData = JSON.parse(
          this.indexData.projectData[0].pre_survey_question_json
        );
        if (this.indexData.projectData[0].has_pre_survey) {
          this.editedItem.preQuestions = preQuestionData.questions;
        }
        this.teams = this.indexData.teams;
        // console.log( this.editedItem.filter_data);
        return true;
      }
      return false;
    },
    getTeamInfo(team_code_id) {
      var teamText = "";
      this.teams.forEach((element) => {
        if (team_code_id == element.id) {
          teamText =
            "Team Name: " +
            element.team_name +
            " Team Code: " +
            element.team_code +
            " Number Of Dasher: " +
            element.numbers_of_dasher;
        }
      });

      return teamText;
    },
    blank_check() {
      return (this.q_blank_status = true);
    },
    back() {
      if (this.editedItem.projectData[0].project_type_id != 2) {
        router.push("/edit-budget");
      } else {
        router.push("/edit-budget2");
      }
    },

    submit() {
      // this.$store.dispatch("updateSurvey", [this.apiUrl, this.editedItem]);
      if (
        this.editedItem.projectInfo.project_type_id == 2 &&
        this.indexData.numberOfResponse < 1
      ) {
        alert("Sorry! Survey locations could not be empty");
      } else {
        // console.log(this.editedItem);
        this.data.questions = this.editedItem.questions;
        this.data.preQuestions = this.editedItem.preQuestions;
        // this.data.project_id = 0;
        this.$store.dispatch("modifySurvey", [
          "project-submit-modify",
          this.data,
        ]);
      }
      this.clicked = true;
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.text_color {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
